import { render, staticRenderFns } from "./WidgetCategoryReviewsBoardMobile.vue?vue&type=template&id=1a1179d3&scoped=true"
import script from "./WidgetCategoryReviewsBoardMobile.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsBoardMobile.vue?vue&type=script&lang=js"
import style0 from "./WidgetCategoryReviewsBoardMobile.vue?vue&type=style&index=0&id=1a1179d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1179d3",
  null
  
)

export default component.exports